import { ViewModel,View } from "binder"
import  { ChartView } from "./chart-view"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { ContentPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";

export class ChartComponent extends FormBuilderComponent{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.name = 'Chart';
        this.canAcceptContent = false;
        this.canAcceptMultipleContent = false;

        this.addProperty("Series","data-b-comp-series",new ContentPropertyType(this),null,false);
    }
    
    CreateInternal(parent: ViewModel): FormBuilderElement {
        let result = new ChartElement(parent);
        return result;    
    }
    
}
export class ChartElement extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ChartView();
    }
    public getTypeId(): string {
        return "VM-5BF456EE-A18B-4761-AC3F-1F6C9BC78ACE"
    }
    public set Series(v: any) { this._Series = v; } public get Series(): any { return this._Series;} private _Series: any;
    
    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitChart(this,parameter);
    }
    
}
